// See: https://github.com/typescript-eslint/typescript-eslint/issues/2715
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function ownerDocument(node) {
    var _a;
    return (_a = node === null || node === void 0 ? void 0 : node.ownerDocument) !== null && _a !== void 0 ? _a : window.document;
}
export default ownerDocument;
//# sourceMappingURL=ownerDocument.js.map